import { ProductReviewsComponent } from "./productReviews.component";

export const ProductReviews = () => {
    return <ProductReviewsComponent />;
};
